import React from 'react'

export default function AcPanel2() {


    let data = [{

        text:"Male sex"
    },
    {

        text:"Older age"
    },
    {

        text:"Family history of heart disease"
    },
    {

        text:"Being postmenopausal"
    },
    {

        text:"Race (African Americans, American Indians, and Mexican Americans are more likely to have heart disease than Caucasians.)"
    },
    {

        text:"Still, there are many heart disease risk factors that can be controlled. By making changes in your lifestyle, you can"
    },
    {

        text:"actually reduce your risk for heart disease. Controllable risk factors for heart disease include:"
    },
    {

        text:`High LDL, or "bad" cholesterol, and low HDL, or "good" cholesterol`
    },
    {

        text:"Physical inactivity"
    },{

        text:"Smoking"
    },
    {

        text:"Obesity (having a BMI greater than 25)"
    },{

        text:"Uncontrolled diabetes"
    },
    {

        text:"High C-reactive protein"
    },{

        text:"Uncontrolled stress, depression, and anger"
    },
    {

        text:"Poor diet"
    },]
    

    return (
        <div>
            <p>There are several risk factors for heart disease; some are controllable, others are not. Uncontrollable risk factors for heart disease include:Male sexOlder ageFamily history of heart diseaseBeing postmenopausalRace (African Americans, American Indians, and Mexican Americans are more likely to have heart disease than Caucasians.)Still, there are many heart disease risk factors that can be controlled. By making changes in your lifestyle, you can actually reduce your risk for heart disease. Controllable risk factors for heart disease include:Smokers have more than twice the risk for heart attack as nonsmokers and are much more likely to die if they suffer a heart attack. Smoking is also the most preventable risk factor. If you smoke, quit. Better yet, never start smoking at all. Nonsmokers who are exposed to constant smoke also have an increased risk.About 67 million people in the U.S. have hypertension, or high blood pressure, making it the most common heart disease risk factor. Nearly one in three adults has systolic blood pressure (the upper number) over 130, and/or diastolic blood pressure (the lower number) over 80, which is the definition of hypertension. Like cholesterol, blood pressure The risk for heart disease increases as your total amount of cholesterol increases. Your total cholesterol goal should be less than 200 mg/dl; HDL, the good cholesterol, higher than 40 mg/dl in men and 50 mg/dl in women (and the higher the better); and LDL should be less than 130 mg/dl in healthy adults. For those with diabetes or multiple risk factors for heart disease, the LDL goal should be less than 100 mg/dl (some experts recommend less than 70 mg/dl if you are very high risk). Interpretation and treatment of cholesterol values must be individualized, taking into account all of your risk factors for heart disease. A diet low in cholesterol and saturated and trans fats and high in complex carbohydrates and good fats (omega 3s) will help lower cholesterol levels and reduce your risk for heart disease. Regular exercise will also help lower "bad" cholesterol and raise "good" cholesterol. Often, medications are needed to reach cholesterol goals.Here are some ways you can reduce your risk of heart disease.QUIT SMOKINGIMPROVE CHOLESTEROL LEVELS.CONTROL HIGH BLOOD PRESSUREAbout 67 million people in the U.S. have hypertension, or high blood pressure, making it the most common heart disease risk factor. Nearly one in three adults has systolic blood pressure (the upper number) over 130, and/or diastolic blood pressure (the lower number) over 80, which is the definition of hypertension. Like cholesterol, blood pressure CONTROL DIABETES.About 67 million people in the U.S. have hypertension, or high blood pressure, making it the most common heart disease risk factor. Nearly one in three adults has systolic blood pressure (the upper number) over 130, and/or diastolic blood pressure (the lower number) over 80, which is the definition of hypertension. Like cholesterol, blood pressure EAT RIGHTExcess weight puts significant strain on your heart and worsens several other heart disease risk factors such as diabetes, high blood pressure, high cholesterol, and triglycerides. Research is showing that obesity itself increases heart disease risk. By eating right and exercising, you can lose weight and reduce your risk of heart ACHIEVE AND MAINTAIN A HEALTHY WEIGHTExcess weight puts significant strain on your heart and worsens several other heart disease risk factors such as diabetes, high blood pressure, high cholesterol, and triglycerides. Research is showing that obesity itself increases heart disease risk. By eating right and exercising, you can lose weight and reduce your risk of heart MANAGE STRESSMany of us lead sedentary lives, exercising infrequently or not at all. People who don't exercise have higher rates of death and heart disease compared to people who perform even mild to moderate amounts of physical activity. Even leisure-time activities like gardening or walking can lower your risk of heart disease. Most people should exercise 30 minutes a day, at moderate intensity, on most days. More vigorous activities are associated with more benefits. Exercise should be aerobic, involving the large muscle groups. Aerobic activities include brisk walking, cycling, swimming, jumping rope, and jogging. If walking is your exercise of choice, use the pedometer goal of 10,000 steps a day. Consult your doctor before starting any exercise program.interpretation and treatment should be individualized, considering your entire risk profile. Control blood pressure through diet, exercise, weight management, watching your salt, and if needed, medications.GET ACTIVEHigh LDL, or "bad" cholesterol, and low HDL, or "good" cholesterolPhysical inactivitySmokingObesity (having a BMI greater than 25)Uncontrolled diabetesHigh C-reactive proteinUncontrolled stress, depression, and angerPoor diet</p>
            <ul>
                {

                    data.map((item, i)=>{
                     
                        return <li key={i}>{item.text}</li>


                    })
                }
            </ul>
        </div>
    )
}
